import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface GeneralSmartInsightsRecommendationSummarySignature {
  Args: {
    label: string;
  };
  Element: HTMLDivElement;
}

<template>
  <div class="flex flex-row items-center gap-100" ...attributes>
    <PrismIcon
      @color="intelligence"
      @name="recommendation"
      @size="extra-small"
    />
    <p class="text-200--medium text-intelligence-default">{{@label}}</p>
  </div>
</template> satisfies TOC<GeneralSmartInsightsRecommendationSummarySignature>;
